<template>
  <div class="flex">
    <svg-icon type="mdi" :path="path"></svg-icon>
    <!-- <ChevronDoubleDown /> -->
  </div>
</template>

<script>
// import ChevronDoubleDown from "vue-material-design-icons/ChevronDoubleDown.vue"

import SvgIcon from '@jamescoyle/vue-icon';
import { mdiChevronDoubleDown } from "@mdi/js"

export default {
  name: "ChevronDoubleDownIcon",
  components: {
    SvgIcon
    // ChevronDoubleDown,
  },
  data() {
    return {
      path: mdiChevronDoubleDown,
    }
  }
}
</script>
